import { Classe } from '../classe/classe.model';
import { BaseEntityAuditada } from '../models/base-entity-auditada.model';
import { Processo } from '../processo/processo.model';

export interface ProcessoRelacionamento extends BaseEntityAuditada {
  id?: number;
  processo?: Processo;
  origemId?: string;
  numeroProcesso?: string;
  tipo?: ProcessoTipoRelacionamento;
  classe?: Classe;
  relacionado?: Processo;
  dataExclusao?: Date;
}

export enum ProcessoTipoRelacionamento {
  APENSO = <any> 'APENSO',
  ACAO_RESCISORIA = <any> 'ACAO_RESCISORIA',
  COMPETENCIA_DELEGADA = <any> 'COMPETENCIA_DELEGADA',
  CONTINENCIA = <any> 'CONTINENCIA',
  CONEXAO = <any> 'CONEXAO',
  DEPENDENCIA = <any> 'DEPENDENCIA',
  DESMEMBRAMENTO = <any> 'DESMEMBRAMENTO',
  INCIDENTAL = <any> 'INCIDENTAL',
  ORIGINARIO = <any> 'ORIGINARIO',
  OUTRO_TIPO_ASSOCIACAO = <any> 'OUTRO_TIPO_ASSOCIACAO',
  PROCESSO_REFERENCIA = <any> 'PROCESSO_REFERENCIA',
  PREVENCAO = <any> 'PREVENCAO',
  PRECEDENTE_DE_UNIFORMIZACAO = <any> 'PRECEDENTE_DE_UNIFORMIZACAO',
  REPERCUSSAO_GERAL = <any> 'REPERCUSSAO_GERAL',
  RECURSO_REPETITIVO = <any> 'RECURSO_REPETITIVO',
  TRASLADO = <any> 'TRASLADO',
  VINCULACAO_INDIRETA = <any> 'VINCULACAO_INDIRETA'
}
